module.exports = __webpack_public_path__ + "img/redq_bg.023eaba7.png";